import { GetTodaysDate } from "motw_core/Services/TimeServices";
import * as React from "react";
import { GoalEditorPanel } from "source/app/presentation/MainPanel/Goals/GoalEditor/GoalEditorPanel/GoalEditorPanel";
import { FormInput } from "source/app/presentation/Shared/Form/Input/FormInput";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { StyleClass } from "../../../../../Shared/Styles/CSS";
import { CanSaveProperty } from "../CanSaveProperty";
import { emptyIGEPStateContainer } from "../GEPState/emptyGEPStateContainer";
import { HandleValueChange } from "../HandleValueChange";
import { GetLastTimeText } from "source/app/presentation/MainPanel/Goals/GoalEditor/GoalEditorPanel/StartDate/GetLastTimeText";

export function StartDate({ GEP }: { GEP: GoalEditorPanel }) {
    let startDateValue = GEP.state.currentState[propertyName];

    return (
        <div>
            <div>
                <FormInput
                    id={`goal_${propertyName}`}
                    label={propertyName}
                    width="170px"
                    type="date"
                    value={startDateValue}
                    onChange={(event) =>
                        HandleValueChange(GEP, event.target.value, propertyName)
                    }
                    onClear={() =>
                        HandleValueChange(
                            GEP,
                            emptyIGEPStateContainer[propertyName],
                            propertyName
                        )
                    }
                    readonly={!CanSaveProperty(propertyName)}
                />
                <IconWithText
                    id="setStartDateToTodayIcon"
                    iconSuffix={EGlyphicon.download}
                    whenClicked={() => SetGoalStartDateToToday(GEP)}
                    withClass={StyleClass(`goalSetStartDateTodayIcon`, {
                        opacity: 0.7,
                        position: "relative",
                        top: "4px",
                        marginLeft: `5px`,
                    })}
                    displayAsBlock={false}
                />
            </div>
            <GetLastTimeText
                {...{
                    startDateValue,
                    datapoints: GEP.state.currentState.datapoints,
                }}
            />
        </div>
    );
}

function SetGoalStartDateToToday(GEP: GoalEditorPanel) {
    HandleValueChange(GEP, GetTodaysDate(), propertyName);
}

const propertyName = "startdate";
